// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gcd-gl-container {
    top: 0.5em !important;
}
.gcd-gl-control {
    background-color: transparent;
    transition: unset !important;
}
.gcd-gl-input {
    top: 0.125em !important;
    left: 40px !important;
}
.gcd-gl-btn {
    height: 100% !important;
    aspect-ratio: 1 !important;
}
.ol-touch .ol-control.gcd-gl-control button {
    font-size: 1.14em;
}
.ol-touch .ol-geocoder.gcd-gl-container {
    font-size: 1.1em;
}
.ol-geocoder.gcd-gl-container {
    box-sizing: border-box;
    font-size: 0.9em;
    left: 0.5em;
    position: absolute;
    top: 4.875em;
}
.ol-geocoder.gcd-gl-container *,
.ol-geocoder.gcd-gl-container :after,
.ol-geocoder.gcd-gl-container :before {
    box-sizing: inherit;
}
.ol-geocoder .gcd-gl-control {
    height: 2.1875em;
    overflow: hidden;
    transition: width 0.2s, height 0.2s;
    width: 2.1875em;
}
.ol-geocoder .gcd-gl-expanded {
    height: 2.1875em;
    width: 15.625em;
}
.ol-geocoder .gcd-gl-input {
    background-color: #fff;
    border: 1px solid #ccc;
    color: #222;
    font-family: inherit;
    font-size: 0.875em;
    left: 2.5em;
    padding: 5px;
    position: absolute;
    top: 0.25em;
    width: 14.84375em;
    z-index: 99;
}
.ol-geocoder .gcd-gl-input:focus {
    border: none;
    box-shadow: inset 0 0 0 1px #4d90fe, inset 0 0 5px #4d90fe;
    outline: none;
}
.ol-geocoder .gcd-gl-search {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: inline-block;
    height: 100%;
    line-height: 1.4;
    outline: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 1.5625em;
    z-index: 100;
}
.ol-geocoder .gcd-gl-search:after {
    color: #333;
    content: "\\2386";
    cursor: pointer;
    display: inline-block;
    font-size: 1.5em;
}
.ol-geocoder .gcd-gl-btn {
    cursor: pointer;
    height: 1.5625em;
    left: 0.125em;
    position: absolute;
    top: 0.125em;
    width: 1.5625em;
}
.ol-geocoder .gcd-gl-btn:after {
    content: "\\1F50D";
}
.ol-geocoder ul.gcd-gl-result {
    background-color: #fff;
    border-radius: 4px;
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.8);
    left: 2em;
    list-style: none;
    margin: 0;
    max-height: 18.75em;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    top: 2.1875em;
    transition: max-height 0.3s ease-in;
    white-space: normal;
    width: 16.25em;
}
.ol-geocoder ul.gcd-gl-result > li {
    border-bottom: 1px solid #eee;
    line-height: 0.875rem;
    overflow: hidden;
    padding: 0;
    width: 100%;
}
.ol-geocoder ul.gcd-gl-result > li > a {
    display: block;
    padding: 3px 5px;
    text-decoration: none;
}
.ol-geocoder ul.gcd-gl-result > li > a:hover {
    background-color: #d4d4d4;
}
.ol-geocoder ul.gcd-gl-result > li:nth-child(odd) {
    background-color: #e0ffe0;
}
.ol-geocoder ul.gcd-gl-result:empty {
    display: none;
}
.ol-geocoder.gcd-txt-container {
    box-sizing: border-box;
    height: 4.375em;
    left: calc(50% - 12.5em);
    position: absolute;
    top: 0.5em;
    width: 25em;
}
.ol-geocoder.gcd-txt-container *,
.ol-geocoder.gcd-txt-container :after,
.ol-geocoder.gcd-txt-container :before {
    box-sizing: inherit;
}
.ol-geocoder .gcd-txt-control {
    background-color: #fff;
    border: 1px solid #ccc;
    height: 4.375em;
    overflow: hidden;
    position: relative;
    width: 100%;
}
.ol-geocoder .gcd-txt-label {
    display: inline-block;
    text-align: center;
    width: 100%;
}
.ol-geocoder .gcd-txt-input {
    background-color: transparent;
    border: none;
    font-family: inherit;
    font-size: 0.875em;
    height: 100%;
    left: 0;
    padding: 5px 30px 5px 40px;
    position: absolute;
    text-indent: 6px;
    top: 0;
    width: 100%;
    z-index: 99;
}
.ol-geocoder .gcd-txt-input:focus {
    box-shadow: inset 0 0 0 1px #4d90fe, inset 0 0 6px #4d90fe;
    outline: none;
}
.ol-geocoder .gcd-txt-search {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: inline-block;
    height: 100%;
    line-height: 100%;
    outline: 0;
    position: absolute;
    right: 0;
    top: 0;
    vertical-align: middle;
    width: 2.5em;
    z-index: 100;
}
.ol-geocoder .gcd-txt-search:after {
    color: #333;
    content: "\\2386";
    cursor: pointer;
    display: inline-block;
    font-size: 2em;
}
.ol-geocoder .gcd-txt-glass {
    display: inline-block;
    height: 100%;
    left: 9px;
    position: absolute;
    top: 26px;
    width: 2.5em;
    z-index: 100;
}
.ol-geocoder .gcd-txt-glass:after {
    content: "\\1F50D";
}
.ol-geocoder ul.gcd-txt-result {
    background-color: #fff;
    border-radius: 4px;
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.8);
    left: 0;
    list-style: none;
    margin: 0;
    max-height: 18.75em;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    top: 4.575em;
    transition: max-height 0.3s ease-in;
    white-space: normal;
    width: 25em;
}
.ol-geocoder ul.gcd-txt-result > li {
    border-bottom: 1px solid #eee;
    line-height: 0.875rem;
    overflow: hidden;
    padding: 0;
    width: 100%;
}
.ol-geocoder ul.gcd-txt-result > li > a {
    display: block;
    padding: 3px 5px;
    text-decoration: none;
}
.ol-geocoder ul.gcd-txt-result > li > a:hover {
    background-color: #d4d4d4;
}
.ol-geocoder ul.gcd-txt-result > li:nth-child(odd) {
    background-color: #e0ffe0;
}
.ol-geocoder ul.gcd-txt-result:empty {
    display: none;
}
.ol-geocoder .gcd-hidden {
    opacity: 0;
    visibility: hidden;
}
.ol-geocoder .gcd-pseudo-rotate:after {
    animation: spin 0.7s linear infinite;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(1turn);
    }
}
.gcd-address,
.gcd-road {
    color: #333;
    font-size: 0.875em;
    font-weight: 500;
}
.gcd-city {
    font-weight: 400;
}
.gcd-city,
.gcd-country {
    color: #333;
    font-size: 0.75em;
}
.gcd-country {
    font-weight: lighter;
}
`, "",{"version":3,"sources":["webpack://./client/src/css/ol-geocoder.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;AACA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;AACA;;;IAGI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,YAAY;IACZ,0DAA0D;IAC1D,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,wCAAwC;IACxC,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;;;IAGI,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,WAAW;AACf;AACA;IACI,0DAA0D;IAC1D,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,wCAAwC;IACxC,OAAO;IACP,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,oCAAoC;AACxC;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB","sourcesContent":[".gcd-gl-container {\n    top: 0.5em !important;\n}\n.gcd-gl-control {\n    background-color: transparent;\n    transition: unset !important;\n}\n.gcd-gl-input {\n    top: 0.125em !important;\n    left: 40px !important;\n}\n.gcd-gl-btn {\n    height: 100% !important;\n    aspect-ratio: 1 !important;\n}\n.ol-touch .ol-control.gcd-gl-control button {\n    font-size: 1.14em;\n}\n.ol-touch .ol-geocoder.gcd-gl-container {\n    font-size: 1.1em;\n}\n.ol-geocoder.gcd-gl-container {\n    box-sizing: border-box;\n    font-size: 0.9em;\n    left: 0.5em;\n    position: absolute;\n    top: 4.875em;\n}\n.ol-geocoder.gcd-gl-container *,\n.ol-geocoder.gcd-gl-container :after,\n.ol-geocoder.gcd-gl-container :before {\n    box-sizing: inherit;\n}\n.ol-geocoder .gcd-gl-control {\n    height: 2.1875em;\n    overflow: hidden;\n    transition: width 0.2s, height 0.2s;\n    width: 2.1875em;\n}\n.ol-geocoder .gcd-gl-expanded {\n    height: 2.1875em;\n    width: 15.625em;\n}\n.ol-geocoder .gcd-gl-input {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    color: #222;\n    font-family: inherit;\n    font-size: 0.875em;\n    left: 2.5em;\n    padding: 5px;\n    position: absolute;\n    top: 0.25em;\n    width: 14.84375em;\n    z-index: 99;\n}\n.ol-geocoder .gcd-gl-input:focus {\n    border: none;\n    box-shadow: inset 0 0 0 1px #4d90fe, inset 0 0 5px #4d90fe;\n    outline: none;\n}\n.ol-geocoder .gcd-gl-search {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    line-height: 1.4;\n    outline: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 1.5625em;\n    z-index: 100;\n}\n.ol-geocoder .gcd-gl-search:after {\n    color: #333;\n    content: \"\\2386\";\n    cursor: pointer;\n    display: inline-block;\n    font-size: 1.5em;\n}\n.ol-geocoder .gcd-gl-btn {\n    cursor: pointer;\n    height: 1.5625em;\n    left: 0.125em;\n    position: absolute;\n    top: 0.125em;\n    width: 1.5625em;\n}\n.ol-geocoder .gcd-gl-btn:after {\n    content: \"\\1F50D\";\n}\n.ol-geocoder ul.gcd-gl-result {\n    background-color: #fff;\n    border-radius: 4px;\n    border-top: none;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.8);\n    left: 2em;\n    list-style: none;\n    margin: 0;\n    max-height: 18.75em;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 0;\n    position: absolute;\n    top: 2.1875em;\n    transition: max-height 0.3s ease-in;\n    white-space: normal;\n    width: 16.25em;\n}\n.ol-geocoder ul.gcd-gl-result > li {\n    border-bottom: 1px solid #eee;\n    line-height: 0.875rem;\n    overflow: hidden;\n    padding: 0;\n    width: 100%;\n}\n.ol-geocoder ul.gcd-gl-result > li > a {\n    display: block;\n    padding: 3px 5px;\n    text-decoration: none;\n}\n.ol-geocoder ul.gcd-gl-result > li > a:hover {\n    background-color: #d4d4d4;\n}\n.ol-geocoder ul.gcd-gl-result > li:nth-child(odd) {\n    background-color: #e0ffe0;\n}\n.ol-geocoder ul.gcd-gl-result:empty {\n    display: none;\n}\n.ol-geocoder.gcd-txt-container {\n    box-sizing: border-box;\n    height: 4.375em;\n    left: calc(50% - 12.5em);\n    position: absolute;\n    top: 0.5em;\n    width: 25em;\n}\n.ol-geocoder.gcd-txt-container *,\n.ol-geocoder.gcd-txt-container :after,\n.ol-geocoder.gcd-txt-container :before {\n    box-sizing: inherit;\n}\n.ol-geocoder .gcd-txt-control {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    height: 4.375em;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n}\n.ol-geocoder .gcd-txt-label {\n    display: inline-block;\n    text-align: center;\n    width: 100%;\n}\n.ol-geocoder .gcd-txt-input {\n    background-color: transparent;\n    border: none;\n    font-family: inherit;\n    font-size: 0.875em;\n    height: 100%;\n    left: 0;\n    padding: 5px 30px 5px 40px;\n    position: absolute;\n    text-indent: 6px;\n    top: 0;\n    width: 100%;\n    z-index: 99;\n}\n.ol-geocoder .gcd-txt-input:focus {\n    box-shadow: inset 0 0 0 1px #4d90fe, inset 0 0 6px #4d90fe;\n    outline: none;\n}\n.ol-geocoder .gcd-txt-search {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    line-height: 100%;\n    outline: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    vertical-align: middle;\n    width: 2.5em;\n    z-index: 100;\n}\n.ol-geocoder .gcd-txt-search:after {\n    color: #333;\n    content: \"\\2386\";\n    cursor: pointer;\n    display: inline-block;\n    font-size: 2em;\n}\n.ol-geocoder .gcd-txt-glass {\n    display: inline-block;\n    height: 100%;\n    left: 9px;\n    position: absolute;\n    top: 26px;\n    width: 2.5em;\n    z-index: 100;\n}\n.ol-geocoder .gcd-txt-glass:after {\n    content: \"\\1F50D\";\n}\n.ol-geocoder ul.gcd-txt-result {\n    background-color: #fff;\n    border-radius: 4px;\n    border-top: none;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.8);\n    left: 0;\n    list-style: none;\n    margin: 0;\n    max-height: 18.75em;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 0;\n    position: absolute;\n    top: 4.575em;\n    transition: max-height 0.3s ease-in;\n    white-space: normal;\n    width: 25em;\n}\n.ol-geocoder ul.gcd-txt-result > li {\n    border-bottom: 1px solid #eee;\n    line-height: 0.875rem;\n    overflow: hidden;\n    padding: 0;\n    width: 100%;\n}\n.ol-geocoder ul.gcd-txt-result > li > a {\n    display: block;\n    padding: 3px 5px;\n    text-decoration: none;\n}\n.ol-geocoder ul.gcd-txt-result > li > a:hover {\n    background-color: #d4d4d4;\n}\n.ol-geocoder ul.gcd-txt-result > li:nth-child(odd) {\n    background-color: #e0ffe0;\n}\n.ol-geocoder ul.gcd-txt-result:empty {\n    display: none;\n}\n.ol-geocoder .gcd-hidden {\n    opacity: 0;\n    visibility: hidden;\n}\n.ol-geocoder .gcd-pseudo-rotate:after {\n    animation: spin 0.7s linear infinite;\n}\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(1turn);\n    }\n}\n.gcd-address,\n.gcd-road {\n    color: #333;\n    font-size: 0.875em;\n    font-weight: 500;\n}\n.gcd-city {\n    font-weight: 400;\n}\n.gcd-city,\n.gcd-country {\n    color: #333;\n    font-size: 0.75em;\n}\n.gcd-country {\n    font-weight: lighter;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
